import { TableId } from '../../lib/table-pipeline/brands';
import { PipelineState } from '../../lib/table-pipeline/contracts';

export interface TablePipelineStateModel {
  byTable: Record<TableId, PipelineState>;
}

export const tablePipelineStateDefaults: TablePipelineStateModel = {
  byTable: {} as Record<TableId, PipelineState>
};
